import { reactNode } from '@shared/node-v1.0.0'

import v200 from '@nodes/unstyled-button-v2.0.0'

export default reactNode(
	'UnstyledButton',
	{
		'v2.0.0': v200,
	},
	{ allowChildren: true, docs: '' }
)
